import {Directive, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';

import {AuthenticationService, ClientProfileService, TenantService} from "../_services";
import {forkJoin} from "rxjs";
import {LoginHelper} from "../helpers";

/**
 * Inactivity directive
 */
@Directive({
  standalone: false,
  selector: '[ngxInactivity]'
})
export class NgxInactivityDirective implements OnInit {

  /**
   * Mouse move event emitter
   */
  public mousemove = new EventEmitter();

  /**
   * Mouse down event emitter
   */
  public mousedown = new EventEmitter();

  /**
   * Keypress event emitter
   */
  public keypress = new EventEmitter();

  /**
   * SetTimeout method id
   */
  public timeoutId: any;

  public startTime: Date;

  /**
   * Inactivity timeout limit (defaults 15 minutes)
   */
  @Input() ngxInactivity: number = window.location.hostname == 'localhost' ? 1440 : 3;

  /**
   * Inactivity interval (defaults 1000 ms)
   */
  @Input() ngxInactivityInterval: number = 1000;

  /**
   * Inactivity callback after timeout
   */
  @Output() ngxInactivityCallback = new EventEmitter();

  /**
   * Attach a mouse move listener
   */
  @HostListener('document:mousemove', ['$event'])
  onMousemove(event) {
    this.mousemove.emit(event);
  }

  /**
   * Atach a mouse down listener
   */
  @HostListener('document:mousedown', ['$event'])
  onMousedown(event) {
    this.mousedown.emit(event);
  }

  /**
   * Attach a key press listener
   */
  @HostListener('document:keypress', ['$event'])
  onKeypress(event) {
    this.keypress.emit(event);
  }

  constructor(public authenticationService: AuthenticationService,
              public settingsService: ClientProfileService,
              private tenantService: TenantService) {
  }

  ngOnInit() {
    /*
     * Merge to flattens multiple Observables together
     * by blending their values into one Observable
     */
    forkJoin([this.tenantService.getCurrent(),
      this.settingsService.getPublicSettings(LoginHelper.getTenantName())
    ])
    .subscribe(t => {
        this.initInactivity(t[1]?.inactivityTimeout || t[0]?.inactivityTimeout || this.ngxInactivity);
      },
      () => {
        this.initInactivity(this.ngxInactivity);
      });

    /*setInterval(() => {
      if (this.startTime) {
        if ((new Date().getTime() - this.startTime.getTime()) > this.ngxInactivity * 60 * 1000) {
          this.authenticationService.logout();
        }
      }
    }, 2000);*/
  }

  initInactivity(time) {
    this.ngxInactivity = time;
    this.mousemove
      .subscribe(() => {
        this.reset();
        this.start();
      });
    this.mousedown
      .subscribe(() => {
        this.reset();
        this.start();
      });
    this.keypress
      .subscribe(() => {
        this.reset();
        this.start();
      });

    this.start();
  }

  /**
   * Start inactivity timer
   */
  public start(): void {

    /**
     * Inactivity callback if timeout (in minutes) is exceeded
     */
    this.startTime = new Date();
    this.timeoutId = setTimeout(() => this.ngxInactivityCallback.emit(true), this.ngxInactivity * 60000);
  }

  /**
   * Reset inactivity timer
   */
  public reset(): void {
    this.startTime = new Date();
    clearTimeout(this.timeoutId);
  }

}
